import React from 'react';
import { Block, BlockBetween, BlockHead, BlockHeadContent } from '../../components/Component';

const AuthTenantLoader = ({ tenant_info, loading_message }) => {
  return (
    <div style={{
      height: tenant_info?.tenant_logo ? "40vh" : "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: "20px"
    }}>
      <Block size="lg" style={{
        maxWidth: "500px",
        width: "100%",
        animation: "fadeIn 0.3s ease-out"
      }}>
        <BlockBetween className="center">
          <BlockHead>
            <BlockHeadContent>
              <div className="brand-logo text-center" style={{
                marginBottom: "2rem",
                display: "flex",
                justifyContent: "center",
                width: "100%"
              }}>
                {tenant_info?.tenant_logo && (
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%"
                  }}>
                    <img
                      className="logo-custom-img-main_app_loading w-70"
                      src={tenant_info?.tenant_logo}
                      alt="logo-dark"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                )}
              </div>

              <div style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "2rem",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                textAlign: "center"
              }}>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <div className="text-soft fw-bold" style={{
                    fontSize: "22px",
                    color: "#2d3748",
                    marginBottom: "1.5rem"
                  }}>
                    {loading_message || "Loading Page..."}
                  </div>
                  <div className="mt-3" style={{ position: "relative" }}>
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{
                        width: "3rem",
                        height: "3rem",
                        borderWidth: "0.25rem"
                      }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
        </BlockBetween>
      </Block>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AuthTenantLoader;